import moment from 'moment'

interface DateRange {
  created_after: string
  created_before: string
  previous_created_after: string
  previous_created_before: string
  past_period: string
}

export const getDateRangeByPeriod = (
  period: string,
  customStartDate?: string | null,
  customEndDate?: string | null
): DateRange => {
  const now = moment()
  let created_after = now.clone().startOf('month')
  let created_before = now.clone().endOf('month')

  const today = now.format('d')
  let past_period = `Past ${today} days`

  if (period === 'week') {
    created_after = now.clone().startOf('week')
    created_before = now.clone().endOf('week')
  }

  if (period === 'all-time') {
    created_before = now
    created_after = now.clone().subtract(1, 'years').startOf('day')

    past_period = 'All Time'
  }
  if (period === 'custom') {
    if (customStartDate && customEndDate) {
      created_before = moment(customEndDate)
      created_after = moment(customStartDate)
      past_period = `Past ${moment(customEndDate).diff(moment(customStartDate), 'days')} days`
    }
  }
  const duration = moment.duration(created_before.diff(created_after))
  const previous_created_after = created_after
    .clone()
    .subtract(duration)
    .format('YYYY-MM-DD')
  const previous_created_before = created_before
    .clone()
    .subtract(duration)
    .format('YYYY-MM-DD')

  return {
    created_after: created_after.format('YYYY-MM-DD'),
    created_before: created_before.format('YYYY-MM-DD'),
    previous_created_after,
    previous_created_before,
    past_period,
  }
}
